import pathfinder from '@fiverr-private/pathfinder';
import { getContext } from '@fiverr-private/fiverr_context';
import fallbackImage from '../../assets/fallback-image.png';
import { ENGINE_TYPE } from '../../shared/constants';
import { FILTER_NAMES } from '../../constants';
import { parseActiveFilters } from '../../utils';

export { getCategoryKey } from './getCategoryKey';

export const handleImageLoadError = (event) => {
    event.target.src = fallbackImage;
};

export const buildGigPageUrl = ({
    username,
    slug,
    packageId,
    extraFast,
    engine,
    position,
    impressionId,
    auctionId,
    source,
}) => {
    const { pageCtxId, queryParameters: { ref } = {} } = getContext();
    const isChoice = engine === ENGINE_TYPE.FIVERR_CHOICE;
    const filtersMapFromRef = parseActiveFilters();
    const packageIncludes = filtersMapFromRef[FILTER_NAMES.PACKAGE_INCLUDES];

    return pathfinder(
        'short_v4_user_gig',
        { username, slug },
        {
            query: {
                ...(pageCtxId && { ref_ctx_id: pageCtxId }),
                ...(packageId && { pckg_id: packageId }),
                ...(ref && { ref }),
                ...(isChoice && { fiverr_choice: isChoice.toString() }),
                ...(extraFast && { extra_fast: extraFast.toString() }),
                ...(packageIncludes && { filtered_factors: packageIncludes }),
                ...(position && { pos: position }),
                ...(impressionId && { imp_id: impressionId }),
                ...(source && { source }),
                ...(auctionId && { ad_key: auctionId }),
            },
        }
    );
};
